import { createFileRoute } from "@tanstack/react-router";
import { WeekCalendar } from "./-components/week-calendar";

export const Route = createFileRoute("/_authenticated/menus/calendar")({
  component: WeekCalendar,
});
